import { render, staticRenderFns } from "./CompleteProfile.vue?vue&type=template&id=7245cde4&scoped=true"
import script from "./CompleteProfile.vue?vue&type=script&lang=ts"
export * from "./CompleteProfile.vue?vue&type=script&lang=ts"
import style0 from "./CompleteProfile.vue?vue&type=style&index=0&id=7245cde4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7245cde4",
  null
  
)

export default component.exports